{
  "home": {
    "title": "Dashboard",
    "welcome": "Welcome back, {{name}}",
    "guest": "Guest",
    "subtitle": "Here's what's happening with your intellectual property today.",
    "currentApplication": "Current Application",
    "applicationProgress": "Application Progress",
    "noActiveApplications": "No Active Applications",
    "createFirst": "Create your first trademark application to get started.",
    "quickActions": "Quick Actions",
    "resumeFiling": "Quote & Payment",
    "resumeFilingDesc": "View your quote and pay",
    "paymentHistory": "Payment History",
    "paymentHistoryDesc": "View receipts & invoices",
    "contactSupport": "Contact Support",
    "contactSupportDesc": "Get help from our team",
    "lastUpdated": "Last updated: {{date}}",
    "newFiling": "New Trademark Check",
    "viewAll": "View All",
    "continueFiling": "View Quote & Payment",
    "payAndFile": "Pay & File",
    "viewQuoteStatus": "View Status",
    "viewFilingStatus": "View Filing Status",
    "activeFilings": "Active Filings",
    "actionRequired": "Action Required",
    "protectedAssets": "Protected Assets",
    "startProtecting": "Start with a free trademark check on our website. You will get a detailed report and an attorney-confirmed quote within 24 hours — no payment needed upfront.",
    "startNewApp": "Start Your Free Check",
    "fromYourAttorney": "From Your Attorney",
    "unnamedTrademark": "Unnamed Trademark",
    "insights": {
      "appInProgress": "Application in Progress",
      "appInProgressMsg": "Check your quote and payment status to move your application forward.",
      "reportPreparing": "Report On Its Way",
      "reportPreparingMsg": "We are preparing your trademark report and quote. Expect an email within 24 hours.",
      "quoteReady": "Your Quote Is Ready",
      "quoteReadyMsg": "Your attorney-confirmed quote is ready. Review it and pay to start your filing.",
      "filingInProgress": "Filing In Progress",
      "filingInProgressMsg": "Your payment is complete. Your trademark application is being prepared for filing.",
      "paymentPending": "Payment Pending",
      "paymentPendingMsg": "Your application is ready for filing. Complete payment to proceed.",
      "startJourney": "Start Your Journey",
      "startJourneyMsg": "Get a free trademark check and quote on our website — no payment required upfront.",
      "analysisComplete": "Analysis Completed",
      "analysisCompleteMsg": "Marko has analysed your trademark. Check the report for potential conflicts.",
      "systemOp": "System Operational",
      "systemOpMsg": "All monitoring systems active"
    }
  },
  "status": {
    "inProgress": "In Progress",
    "quoteRequested": "Preparing your report",
    "quoteSent": "Quote ready",
    "paymentPending": "Payment Pending",
    "paymentComplete": "Payment Complete",
    "pendingFiling": "Pending Filing",
    "filingInProgress": "Filing in Progress",
    "filed": "Filed",
    "registered": "Registered",
    "completed": "Completed",
    "cancelled": "Cancelled",
    "refunded": "Refunded",
    "partiallyRefunded": "Partially Refunded"
  },
  "payments": {
    "sectionTitle": "Quote & Payment",
    "sectionSubtitle": "Review your quote, sign the declaration, and complete payment",
    "noApplicationTitle": "No application yet",
    "noApplicationMsg": "Start with a free trademark check on our website. We will email you a detailed report and quote within 24 hours.",
    "startFreeCheck": "Start your free check",
    "reportPreparingTitle": "Your report is being prepared",
    "reportPreparingMsg": "Our team is reviewing your trademark and preparing your detailed report and quote. We will email it to you within 24 hours.",
    "reportForTrademark": "Trademark: {{name}}",
    "loadingQuote": "Loading your quote…",
    "noQuoteTitle": "Your quote is not ready yet",
    "noQuoteMsg": "We are still finalising the quote for this application. You will receive an email as soon as it is ready. If you think this is a mistake, reply to any of our emails and we will sort it out.",
    "quoteTitle": "Your quote",
    "quoteSubtitle": "Review your filing fees and complete payment",
    "quoteSubtitleConfirmed": "Confirmed by our attorneys — this is the exact amount you will be charged.",
    "breakdown": "Quote breakdown",
    "countries": "Countries",
    "classes": "Classes",
    "serviceFee": "Service fee",
    "governmentFees": "Government filing fees",
    "filingFee": "Trademark filing",
    "discount": "Multi-country discount",
    "total": "Total",
    "chargedIn": "Charged in {{currency}}",
    "pendingRetry": "A previous payment attempt is pending. You can proceed to try again.",
    "attorneyServiceFee": "Trade mark attorney service fee",
    "quoteDocTitle": "Quote",
    "dateOfIssue": "Date of issue",
    "quoteValidity": "Valid for 30 days",
    "trademarkDetails": "Trade mark details",
    "markName": "Trade mark",
    "markType": "Type",
    "applicant": "Applicant",
    "viewFullReport": "View your full report",
    "hideFullReport": "Hide your full report",
    "reportExpanderHint": "The trademark report our team prepared for you",
    "settingUpPayment": "Setting up secure payment…",
    "paymentRetry": "Try again",
    "overlayUnlock": "Tick the declaration above to pay",
    "overlayUnlockApplicant": "Add your applicant details above to pay",
    "overlayUnlockBoth": "Add your applicant details and tick the declaration above to pay",
    "applicantTbc": "To be confirmed",
    "applicantDetails": {
      "title": "Applicant details",
      "subtitle": "The trade mark will be registered in this name. The trade mark office requires the applicant’s name and postal address to file.",
      "nameLabel": "Applicant name",
      "namePlaceholder": "Full legal name or company name",
      "streetLabel": "Street address",
      "streetPlaceholder": "123 Example Street",
      "cityLabel": "Suburb / City",
      "stateLabel": "State",
      "optional": "(optional)",
      "zipLabel": "Postcode",
      "countryLabel": "Country",
      "saving": "Saving…",
      "saved": "Saved",
      "saveError": "Could not save your details. They will be saved again as you keep typing."
    },
    "declaration": {
      "loading": "Loading declaration…",
      "title": "Authorisation & Declaration",
      "subtitle": "Required before we can file your trademark application on your behalf",
      "combined": "I confirm I am authorised to file this trade mark, that the information in this application is true and accurate, and I appoint MarkoTM as my agent to file and manage this application on my behalf. I accept the",
      "signedBy": "Signed by",
      "signedOn": "on {{date}}",
      "saveError": "Could not save your declaration. Please try again."
    },
    "report": {
      "title": "Your trademark report",
      "subtitle": "Prepared by our team",
      "preparedOn": "Prepared by our team on {{date}}",
      "sections": {
        "overview": "Overview",
        "markAssessment": "Mark assessment",
        "registerFindings": "Register findings",
        "coverageRationale": "Coverage rationale",
        "ourRecommendation": "Our recommendation",
        "nextSteps": "Next steps"
      },
      "matchesTitle": "IP Australia register results",
      "matchName": "Mark",
      "matchNumber": "Number",
      "matchStatus": "Status",
      "matchClasses": "Classes"
    }
  },
  "sidebar": {
    "dashboard": "Dashboard",
    "overview": "Overview",
    "quoteAndPayment": "Quote & Payment",
    "quoteAndPaymentDesc": "Review your quote and pay",
    "myPortfolio": "My Portfolio",
    "viewTrademarks": "View your trademarks",
    "renewals": "Renewals",
    "upcomingDeadlines": "Upcoming deadlines",
    "currentApplication": "Current Application",
    "settings": "Settings",
    "portfolio": "My Portfolio",
    "newApplication": "New Application",
    "filingProgress": "Filing Progress",
    "documents": "Documents",
    "billing": "Billing"
  },
  "header": {
    "notifications": "Notifications",
    "profile": "Profile",
    "logout": "Log Out"
  },
  "attorney": {
    "name": "Ken McInnes",
    "title": "Head of Trademark Strategy",
    "greeting": "Welcome to your secure IP dashboard. You can follow your trade mark's progress here, and it makes it easy to stay in touch with your assigned trade mark attorney at every step."
  },
  "marko": {
    "analysisComplete": "I've analysed your trademark! Click to see my recommendations.",
    "multiCountry": "Filing in multiple countries? I'll help you prioritise.",
    "thinking": "Marko is thinking...",
    "askMe": "Ask me anything about trademarks",
    "clickToChat": "Click to chat →"
  },
  "application": {
    "create": "Create Application",
    "createNew": "Create New Application",
    "name": "Application Name",
    "namePlaceholder": "Give your trademark application a name",
    "nameHelp": "This helps organise your IP portfolio and keeps track of your filing progress.",
    "delete": "Delete Application",
    "deleteConfirm": "Are you sure you want to delete this application? This action cannot be undone.",
    "status": "Application Status",
    "progress": "Progress"
  }
}
